<template>
	<div class="form-inputs">
		<FormLabelTooltip :name="name" :label="label" />
		<Multiselect
			v-model="selectedOptions"
			@change="
				(event) => {
					$emit('input', event.target.value);
				}
			"
			@select="
				(event) => {
					$emit('select', event);
				}
			"
			@remove="
				(event) => {
					$emit('select', event);
				}
			"
			:options="options"
			:multiple="true"
			:taggable="true"
			:max="max"
			:close-on-select="false"
			:clear-on-select="false"
			:placeholder="placeholder"
			:preselect-first="false"
			:class="{ error: error }"
		>
			<template slot="selection" slot-scope="{ values, search, isOpen }">
			</template>
		</Multiselect>
	</div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';

export default {
	name: 'FormDropdownMultiselect',
	components: {
		Multiselect,
		FormLabelTooltip,
	},
	props: [
		'name',
		'options',
		'max',
		'label',
		'placeholder',
		'required',
		'value',
		'error',
	],
	data() {
		return {
			selectedOptions: [],
		};
	},
	mounted() {
		this.selectedOptions = this.value;
	},
	watch: {
		value(newValue) {
			this.selectedOptions = newValue;
		},
	},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect,
.multiselect__input,
.multiselect__single {
	color: $text-base-color !important;
	font-size: inherit !important;
	padding-left: 0 !important;

	&:hover {
		cursor: pointer;
	}
}

.multiselect .multiselect__tags {
	min-height: 44px;
	border-radius: $b360-border-radius-medium;
	border: $b360-border-width-thin solid $border-color-light;
	color: $subheader-color;
}

.multiselect {
	&__tag {
		background: $brand-teal;
	}
}

.error .multiselect__tags {
	border: 1px solid $error;
}

.multiselect__option {
	white-space: normal;

	&--highlight {
		background: $shadow-color;
		color: $text-base-color;

		&:after {
			content: '';
			background: $shadow-color;
			color: $text-base-color;
		}
	}

	&--selected {
		background: $brand-teal;
		color: $white;

		&:after {
			content: '';
			color: $white;
		}

		&.multiselect__option--highlight {
			background: $brand-teal;

			&:after {
				content: 'x';
			}
		}
	}
}

.item + .item:before {
	content: ', ';
}
</style>
